export interface ResponsiveImageSource {
  media: string;
  url: string;
  density: number;
}

export interface ResponsivePreloadSource {
  media: string;
  href: string;
}

function getImageHref(src: string, width: number, density: number): string {
  return src.replace('format=auto', `format=auto,width=${width * density}`);
}

function getImageUrl(src: string, width: number, density: number): string {
  return `${getImageHref(src, width, density)} ${density}x`;
}

export function getResponsiveImageSources(src: string, breakpoints: number[]): ResponsiveImageSource[] {
  const sortedBreakpoints = [...breakpoints].sort((a, b) => a - b);
  const sources: ResponsiveImageSource[] = [];

  for (const width of sortedBreakpoints) {
    sources.push({
      media: `(max-width: ${width}px) and (min-resolution: 2dppx)`,
      url: getImageUrl(src, width, 2),
      density: 2,
    });
    sources.push({
      media: `(max-width: ${width}px)`,
      url: getImageUrl(src, width, 1),
      density: 1,
    });
  }

  return sources;
}

export function getResponsivePreloadSources(src: string, breakpoints: number[]): ResponsivePreloadSource[] {
  const sortedBreakpoints = [...breakpoints].sort((a, b) => a - b);
  const sources: ResponsivePreloadSource[] = [];
  const maxBreakpoint = sortedBreakpoints[sortedBreakpoints.length - 1];

  for (let index = 0; index < sortedBreakpoints.length; index++) {
    const width = sortedBreakpoints[index];
    const previousWidth = index > 0 ? sortedBreakpoints[index - 1] : 0;

    if (previousWidth === 0) {
      sources.push({
        media: `(max-width: ${width}px) and (min-resolution: 2dppx)`,
        href: getImageHref(src, width, 2),
      });
      sources.push({
        media: `(max-width: ${width}px) and (max-resolution: 1.99dppx)`,
        href: getImageHref(src, width, 1),
      });
    } else {
      sources.push({
        media: `(min-width: ${previousWidth + 1}px) and (max-width: ${width}px) and (min-resolution: 2dppx)`,
        href: getImageHref(src, width, 2),
      });
      sources.push({
        media: `(min-width: ${previousWidth + 1}px) and (max-width: ${width}px) and (max-resolution: 1.99dppx)`,
        href: getImageHref(src, width, 1),
      });
    }
  }

  if (maxBreakpoint) {
    sources.push({
      media: `(min-width: ${maxBreakpoint + 1}px)`,
      href: src,
    });
  }

  return sources;
}
